var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFallbackImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 70,
    viewBox: "0 0 62 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.28418 21.0632C0.28418 20.4427 0.935464 20.0338 1.50143 20.2989L28.8042 33.1021C29.1028 33.2431 29.2934 33.5392 29.2934 33.8663V68.872C29.2934 69.4924 28.6421 69.9013 28.0761 69.6362L0.773354 56.833C0.47473 56.692 0.28418 56.3959 0.28418 56.0688V21.0632Z",
    fill: "url(#paint0_linear_548_25539)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5596 68.8552C33.5596 69.4813 34.2194 69.8902 34.7853 69.6166L61.2349 56.8389C61.5278 56.6979 61.7155 56.4018 61.7155 56.0774V21.0803C61.7155 20.4542 61.0557 20.0453 60.4898 20.3188L34.0402 33.0966C33.7473 33.2376 33.5596 33.5337 33.5596 33.858V68.8524V68.8552Z",
    fill: "url(#paint1_linear_548_25539)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.82869 15.7818C1.19447 15.4716 1.19447 14.5748 1.82869 14.2646L30.1439 0.370082C30.3828 0.251639 30.6615 0.251639 30.9004 0.370082L59.2128 14.2646C59.8442 14.5748 59.8442 15.4716 59.2128 15.7818L30.9004 29.6763C30.6615 29.7948 30.3828 29.7948 30.1439 29.6763L1.82869 15.7818Z",
    fill: "url(#paint2_linear_548_25539)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_548_25539",
    x1: 29.2934,
    y1: 34.5458,
    x2: 0.474352,
    y2: 57.6259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEAEAE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_548_25539",
    x1: 33.5596,
    y1: 34.546,
    x2: 61.5342,
    y2: 56.6313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEAEAE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_548_25539",
    x1: 30.5197,
    y1: 0.28125,
    x2: 30.5197,
    y2: 29.7652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEAEAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallbackImg);
export default __webpack_public_path__ + "static/media/fallback_img.648c128ebb4f1d7446defc8621f09f3f.svg";
export { ForwardRef as ReactComponent };